import { HttpErrorResponse } from '@angular/common/http';

/**
 * Raised by `RestApiService.saveCurrencyEdit` when the rename (`PUT /Currency/:id`) went through but the rate
 * that followed (`POST /CurrencyRates/0`) failed: the currency is already renamed, only the rate is missing.
 * Retrying the dialog is safe -- the rename is idempotent -- so this only changes the message.
 */
export class CurrencyPartialSaveError extends Error {
  constructor(public readonly cause: unknown) {
    super('Currency renamed, rate not saved');
  }
}

/**
 * Turns a failed currency save (`createCurrencyRate` / `updateCurrency` / `saveCurrencyEdit`) into the text shown
 * inside the currency dialog: a permissions message on 403, the API's own `{ error }` text (400 / 404 / 409) when
 * it sent one, else a generic line. A `CurrencyPartialSaveError` says the rename was saved and the rate was not.
 */
export function currencySaveErrorText(err: unknown): string {
  if (err instanceof CurrencyPartialSaveError) {
    return 'Назву/код збережено, але курс не збережено: ' + currencySaveErrorText(err.cause);
  }
  const http = (err instanceof HttpErrorResponse) ? err : null;
  if (http?.status === 403) { return 'Недостатньо прав для зміни валют'; }
  const body = http?.error;
  if (body && typeof body.error === 'string') { return body.error; }
  return 'Не вдалося зберегти' + (http ? ' (' + http.status + ')' : '');
}
